export default __webpack_public_path__ + "static/media/logo_clara.63e51ddc.svg";